import { Navigate, useLocation } from "react-router-dom";

const WebinarHomeRedirect = () => {
  const location = useLocation();

  return <Navigate to={`/hydroponic-webinar${location.search}`} replace />;
};

export default WebinarHomeRedirect;
